import { Component, Input, OnInit } from '@angular/core';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { OverviewSummaryComponent, OverviewSummaryModel } from '../overview-summary/overview-summary.component';

@Component({
	selector: 'app-overview-summary-r7',
	templateUrl: './overview-summary-r7.component.html'
})
// tslint:disable-next-line:component-class-suffix
export class OverviewSummaryComponentR7 extends OverviewSummaryComponent implements OnInit {
	@Input() enableproductdetails;
	public showProductDetails: boolean = true;
	private productWithSubtypes = ['Display', 'Pre Roll'];

	constructor(public analyticsService: AnalyticsService, protected analyticsDataModel: AnalyticsDataModel) {
		super(analyticsService, analyticsDataModel);
	}

	ngOnInit(): void {
		super.ngOnInit();
		this.showProductDetails = !UtilityService.isUndefinedOrNull(this.enableproductdetails) && this.enableproductdetails !== 'undefined' && this.enableproductdetails !== 'null'
			? JSON.parse(decodeURI(this.enableproductdetails))
			: this.showProductDetails;
	}

	mapOverviewSummaryResponseToModel(responseArray: any[]): OverviewSummaryModel[] {
		const overviewSummary: OverviewSummaryModel[] = [];
		let count = 0;
		for (const response of responseArray) {
			const overviewSummaryObj: OverviewSummaryModel = {} as OverviewSummaryModel;
			overviewSummaryObj.productId = parseInt(response.product_id);
			overviewSummaryObj.mainId = parseInt(response.main_id);
			overviewSummaryObj.productName = this.getProductName(response.product_name, response.main_id);
			overviewSummaryObj.productName =
				overviewSummaryObj.productName.toLowerCase() == 'connected tv' ||
				overviewSummaryObj.productName.toLowerCase() == 'ctv'
					? 'CTV/OTT'
					: overviewSummaryObj.productName;
			overviewSummaryObj.isParent = UtilityService.toTrueOrFalse(overviewSummaryObj.mainId);
			overviewSummaryObj.parentIndex = count;
			overviewSummaryObj.parentClass = overviewSummaryObj.isParent
				? this.getClassByIndex(overviewSummaryObj.parentIndex)
				: '';
			overviewSummaryObj.impressions = parseFloat(response.impressions);
			overviewSummaryObj.clicks = parseFloat(response.clicks);
			overviewSummaryObj.clickRate = this.calculateRate(overviewSummaryObj.clicks, overviewSummaryObj.impressions);
			overviewSummaryObj.viewThroughs = parseFloat(response.view_throughs);
			overviewSummaryObj.viewThroughRate = this.calculateRate(
				overviewSummaryObj.viewThroughs,
				overviewSummaryObj.impressions
			);
			overviewSummaryObj.visits = parseFloat(response.visits);
			overviewSummaryObj.visitRate = this.calculateRate(overviewSummaryObj.visits, overviewSummaryObj.impressions);
			if (overviewSummaryObj.isParent) {
				count++;
			}
			if (this.showProductDetails) {
				overviewSummary.push(overviewSummaryObj);
			} else if (overviewSummaryObj.mainId === 1) {
				overviewSummary.push(overviewSummaryObj);
			}
		}
		return overviewSummary;
	}

	getProductName(initName: string, mainId: string): string {
		if (parseInt(mainId)) {
			return initName;
		}
		if (initName === 'Retargeting') {
			return 'Audience Extension (Retargeting)';
		}

		if (this.productWithSubtypes.includes(initName)) {
			return 'Audience Extension (Non Retargeting)';
		}

		return initName;
	}
}
